import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { btnGhost, btnPrimary, fieldInput } from "@/admin/ui";

export default function NoteDialog({ reg, onClose, onSave }) {
  const [note, setNote] = useState("");
  useEffect(() => setNote(reg?.note || ""), [reg]);
  return (
    <Dialog open={!!reg} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg rounded-none bg-warm" data-testid="note-dialog">
        <DialogHeader>
          <DialogTitle className="font-serif-display text-[26px] font-normal">Belső jegyzet</DialogTitle>
          <DialogDescription className="font-body text-[13.5px]">{reg?.name} — csak te látod.</DialogDescription>
        </DialogHeader>
        <textarea rows={5} value={note} onChange={(e) => setNote(e.target.value)} maxLength={2000} data-testid="note-dialog-text" className={`${fieldInput} resize-y`} />
        <div className="flex justify-end gap-3 pt-2">
          <button type="button" onClick={onClose} className={btnGhost} data-testid="note-dialog-cancel">Mégse</button>
          <button type="button" onClick={() => onSave(reg, note)} className={btnPrimary} data-testid="note-dialog-save">Jegyzet mentése</button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
